// Configuración de categorías para elementos dibujados
import { useCategoriesStore } from '../stores/categoriesStore';

export interface Category {
    id: string;
    label: string;
    color: string;
    computo: number | null;
}

export interface CategoryConfig {
    [key: string]: {
        color?: string;
        computo?: number | null;
    };
}

export const CATEGORIES: Category[] = [
    {
        id: "VPP",
        label: "Vivienda (planta principal)",
        color: "rgba(255, 87, 34, 0.7)",
        computo: 100
    },
    {
        id: "ZC",
        label: "Zonas Comunes",
        color: "rgba(156, 39, 176, 0.7)",
        computo: null
    },
    {
        id: "PI",
        label: "Piscina",
        color: "rgba(0, 0, 255, 0.7)",
        computo: null
    },
    {
        id: "TBC",
        label: "Terraza o balcón cubierto",
        color: "rgba(76, 175, 80, 0.7)",
        computo: 50
    },
    {
        id: "TBD",
        label: "Terraza o balcón descubierto",
        color: "rgba(139, 195, 74, 0.7)",
        computo: 50
    },
    {
        id: "SSH",
        label: "Sótano o semisótano habitable",
        color: "rgba(33, 150, 243, 0.7)",
        computo: 100
    },
    {
        id: "SSNH",
        label: "Sótano o semisótano no habitable",
        color: "rgba(100, 181, 246, 0.7)",
        computo: 50
    },
    {
        id: "AH",
        label: "Altillo habitable",
        color: "rgba(255, 193, 7, 0.7)",
        computo: 100
    },
    {
        id: "ANH",
        label: "Altillo no habitable",
        color: "rgba(255, 235, 59, 0.7)",
        computo: 50
    },
    {
        id: "TV",
        label: "Trastero vinculado",
        color: "rgba(121, 85, 72, 0.7)",
        computo: 50
    },
    {
        id: "GV",
        label: "Garaje vinculado",
        color: "rgba(84, 110, 122, 0.7)",
        computo: 50
    },
    {
        id: "PC",
        label: "Porche cubierto",
        color: "rgba(158, 158, 158, 0.7)",
        computo: 50
    }
];

// Función helper para obtener el color de una categoría
// Usa el store de categorías en lugar de sessionStorage directo
export function getCategoryColor(categoryId: string): string {
    const store = useCategoriesStore.getState();
    // Asegurar que las categorías estén inicializadas
    if (store.categories.length === 0) {
        store.initializeCategories();
    }
    return store.getCategoryColor(categoryId);
}

// Función helper para obtener la etiqueta de una categoría
// Usa el store de categorías en lugar de sessionStorage directo
export function getCategoryLabel(categoryId: string): string {
    const store = useCategoriesStore.getState();
    // Asegurar que las categorías estén inicializadas
    if (store.categories.length === 0) {
        store.initializeCategories();
    }
    return store.getCategoryLabel(categoryId);
}

// Función helper para verificar si una categoría es "zonas_comunes_edificio"
// Usa el store de categorías
export function isZonasComunesEdificio(categoryId: string): boolean {
    const store = useCategoriesStore.getState();
    return store.isZonasComunesEdificio(categoryId);
}

// Función helper para obtener el cómputo por defecto de una categoría
// Usa el store de categorías en lugar de sessionStorage directo
export function getCategoryComputo(categoryId: string): number | null {
    const store = useCategoriesStore.getState();
    // Asegurar que las categorías estén inicializadas
    if (store.categories.length === 0) {
        store.initializeCategories();
    }
    return store.getCategoryComputo(categoryId);
}
